// Entry point for the build script in your package.json
import '@hotwired/turbo-rails';
import './stimulus';
import './range_polyfill';
import './scroll_to_top';
import './session_expiration';
import './reader_focus_transitions';
import { t } from './i18n.js';
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import select2 from 'select2/dist/js/select2.full';
select2(window.$);

function initTimeZoneSelect() {
  $('.timezone-select').each(function () {
    const $select = $(this);
    if (!$select.data('select2')) {
      $select.select2({
        placeholder: t('select_timezone', 'Select your time zone'),
        width: '100%',
        allowClear: true,
        ajax: {
          url: '/time_zones',
          dataType: 'json',
          delay: 250,
          data: params => ({ q: params.term }),
          processResults: data => ({ results: data })
        }
      });

      // Hide the original select element in case CSS fails to do so
      $select.hide();

      const selectedValue = $select.data('selected-value');
      if (selectedValue) {
        const option = new Option(selectedValue, selectedValue, true, true);
        $select.append(option).trigger('change');
      }
    }
  });
}

document.addEventListener('turbo:load', () => {
  initTimeZoneSelect();
});
